// extracted by mini-css-extract-plugin
module.exports = {"header":"CardHeader_header__3usRB","badgeContainer":"CardHeader_badgeContainer__2GzGw","noBadge":"CardHeader_noBadge__31zyl"};